import { createRoot } from 'react-dom/client'
import { EntitiesStore } from 'entities/EntitiesExport'
import { CallPopUpGlobalStore } from 'widgets/CallPopUp'
import 'app/styles/all.scss'
import { resetGlobalVariables } from 'app/shared/lib/resetGlobalVariables'
import { CallPopupService } from 'app/Integration/service/CallPopup'
import { SidebarService } from 'app/Integration/service/Sidebar'
import { SettingsMenuService } from 'app/Integration/service/SettingsMenu'
import { OverlayService } from 'app/Integration/service/Overlay'
import { BannerService } from 'app/Integration/service/Banners'
import { NextService } from 'app/Integration/service/Next'

resetGlobalVariables()

const entities = new EntitiesStore()
const callPopUpGlobalStore = new CallPopUpGlobalStore(entities)

/* Call popup service */

window.initCallPopup = () => {
  const element = document.getElementById('portal')
  if (!!element)
    createRoot(element).render(
      <CallPopupService entities={entities} callPopUpGlobalStore={callPopUpGlobalStore} />
    )
}

/* Sidebar service */

window.initSidebar = () => {
  const element = document.getElementById('sidebar')

  if (!!element) {
    const sidebar = createRoot(element)

    window.resetSidebar = () => sidebar.unmount()

    sidebar.render(
      <SidebarService entities={entities} callPopUpGlobalStore={callPopUpGlobalStore} />
    )
  }
}

/* Settings menu service */

window.initSettingsMenu = () => {
  const element = document.getElementById('settings-menu')

  if (!!element) {
    const settingsMenu = createRoot(element)

    window.resetSettingsMenu = () => settingsMenu.unmount()

    settingsMenu.render(
      <SettingsMenuService entities={entities} callPopUpGlobalStore={callPopUpGlobalStore} />
    )
  }
}

/* Overlay service */

window.initOverlayReact = () => {
  const element = document.getElementById('app-overlay')
  if (!!element)
    createRoot(element).render(
      <OverlayService entities={entities} callPopUpGlobalStore={callPopUpGlobalStore} />
    )
}

/* Banner Service */

window.initBannerReact = () => {
  const element = document.getElementById('alert-banners')
  if (!!element) {
    const root = createRoot(element)

    window.resetBannerReact = () => root.unmount()

    root.render(<BannerService entities={entities} callPopUpGlobalStore={callPopUpGlobalStore} />)
  }
}

/* Next service */

window.initNextReact = () => {
  const element = document.getElementById('app-next')

  if (!!element) {
    const next = createRoot(element)

    window.resetNextReact = () => next.unmount()

    next.render(<NextService entities={entities} callPopUpGlobalStore={callPopUpGlobalStore} />)
  }
}
